
import { Component, Vue } from 'vue-property-decorator'
import { colorList } from '@/core/pageConfig'
import { addGoodsBrand, modifyGoodsBrand } from "@/api/commodity";
import { Getter } from "vuex-class";

interface TagOption {
  brandName: string,
  companyId: string,

}

@Component
export default class addBrand extends Vue {
  @Getter companyId!: string

  labelWidth = 120;

  formData: TagOption = {
    companyId: '',
    brandName: '',
  }
  colors: string[] = colorList
  visible = false

  created () {
    // this.formData.companyId = this.companyId
    // if (this.$isEdit) {
    //   const data = JSON.parse(this.$route.query.data as string)
    //   this.formData.brandName = data.brandName
    // }
  }

  showModal () {
    this.resetData()
    this.visible = true;
    (this.$refs.handleForm as any).resetValidation()
  }
  resetData () {
    this.formData.brandName = ''
  }

  addSure () {
    (this.$refs.handleForm as any).validate().then(() => {
      addGoodsBrand(this.formData).then(() => {
        this.$toast.success(`商品品牌新增成功！`);
        this.$emit('on-save')
        this.handleCancel()
      })
    })
  }

  handleCancel () {
    this.visible = false
  }

}
